import { render, staticRenderFns } from "./CentralReservas.vue?vue&type=template&id=f7b88c50&scoped=true"
import script from "./CentralReservas.vue?vue&type=script&lang=js"
export * from "./CentralReservas.vue?vue&type=script&lang=js"
import style0 from "./CentralReservas.vue?vue&type=style&index=0&id=f7b88c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b88c50",
  null
  
)

export default component.exports